<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="merchants"
      item-key="nmid"
      :options.sync="options"
      :server-items-length="totalMerchants"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50],
        // showFirstLastPage: true,
      }"
      sort-by="id"
      fixed-header
      :style="{ padding: '10px', height: '70vh' }"
    >
      <template v-slot:[`body.prepend`]>
        <table-filter :search.sync="search" v-on:getDataParent="getData" />
      </template>
      <template v-slot:top>
        <table-top
          :loading="loading"
          :listButton="listButton"
          v-on:getDataParent="getData"
          v-on:addItemParent="registerMerchant"
          v-on:exportItemParent="exportItem"
        />
      </template>
      <template v-slot:item="{ item, index }">
        <table-item
          :options="options"
          :selectedRow="selectedRow"
          :item="item"
          :index="index"
          v-on:openSerialNumberDialogParent="openSerialNumberDialog"
          v-on:selectRowParent="selectRow"
          v-on:listItemParent="listItem"
          v-on:editItemParent="editItem"
          v-on:editItemNonParent="editItemNon"
          v-on:closeMerchantParent="closeMerchant"
          v-on:blockUnblockMerchantParent="blockUnblockMerchant"
        />
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="clearSearch"> Reset </v-btn>
      </template>
    </v-data-table>
    <serial-number-dialog
      :title="dialogTitle"
      :value="dialog"
      :formData="formSn"
      :loading="loading"
      :mode="mode"
      @input="dialog = $event"
      @cancel="cancel"
      @save="save"
    />
  </v-card>
</template>

<script>
import { date } from '../../../lib/helpers';

export default {
  components: {
    TableFilter: () =>
      import('../../../components/table/MerchantInputerFilter.vue'),
    TableItem: () => import('../../../components/table/MerchantItem.vue'),
    TableTop: () => import('../../../components/table/TableTop.vue'),
    SerialNumberDialog: () => import('../../../components/SerialNumberDialog.vue'),
  },
  data: () => ({
    listButton: {
      buttonRestart: true,
      buttonAdd: { label: 'New Merchant' },
      buttonDots: true,
      buttonDotsExt: [
        {
          link: '/inputer/merchant/add/bulk-upload',
          show: true,
          icon: 'mdi-cloud-upload',
          title: 'Bulk Upload Add',
          voidStatus: false,
        },
        {
          link: '/inputer/merchant/block-unblock/bulk-upload',
          show: true,
          icon: 'mdi-cloud-upload',
          title: 'Bulk Upload Block/Unblock Merchant',
          voidStatus: false,
        },
        {
          link: '/inputer/merchant/update-pten/bulk-upload',
          show: true,
          icon: 'mdi-cloud-upload',
          title: 'Bulk Upload Update PTEN',
          voidStatus: false,
        },
        {
          link: '/inputer/merchant/update-non-pten/bulk-upload',
          show: true,
          icon: 'mdi-cloud-upload',
          title: 'Bulk Upload Update Non PTEN',
          voidStatus: false,
        },
        {
          link: 'exportItemParent',
          show: true,
          icon: 'mdi-file-excel',
          title: 'Export to excel',
          voidStatus: true,
        },
      ],
    },
    options: {},
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'id',
        width: '10',
        sortable: false,
      },
      {
        text: 'Source Onboarding',
        value: 'source_onboarding',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Nama Merchant',
        value: 'merchant_name',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'MID',
        value: 'mid',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'NMID',
        value: 'nmid',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'MPAN',
        value: 'mpan',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Alamat Lengkap',
        value: 'address',
        width: '250',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Kriteria Merchant',
        value: 'merchant_criteria',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'No. Handphone',
        value: 'mobile_phone',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Jenis QR',
        value: 'qr_type',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Serial Number',
        value: 'sn',
        width: '150',
        align: 'start',
        sortable: false,
      },   
      {
        text: 'Tanggal Active',
        value: 'created_at',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Tanggal Inactive',
        value: 'deactivated_at',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Status',
        value: 'status',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Action',
        value: 'actions',
        align: 'center',
        width: '50',
        sortable: false,
      },
    ],
    search: {
      source_onboarding: '',
      merchant_name: '',
      mid: '',
      nmid: '',
      mpan: '',
      qr_type: '',
      sn: '',
      deactivated_at: null,
      mobile_phone: '',
      merchant_criteria: '',
      address: '',
      status: '',
      created_at: null,
    },
    selectedRow: '',
    dialog: false,
    formSn: {
      mid: '',
      merchant_name: '',
      sn: ''
    }
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.inputer.merchant.flashErrorMessage;
    },
    flashError: {
      get() {
        return this.$store.state.inputer.merchant.flashError;
      },
      set() {
        this.$store.commit('inputer/merchant/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.inputer.merchant.errors;
    },
    loading() {
      return this.$store.state.inputer.merchant.loading;
    },
    merchants() {
      return this.$store.state.inputer.merchant.allMerchants;
    },
    totalMerchants() {
      return this.$store.state.inputer.merchant.totalMerchants;
    },
    totalPage() {
      return this.$store.state.inputer.merchant.totalPage;
    },
    dialogTitle() {
      return this.formSn.sn ? 'Edit Serial Number' : 'Add Serial Number';
    },
    mode() {
      return this.formSn.sn ? 'edit' : 'add';
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  async mounted() {
    this.$store.commit('inputer/merchant/clearMerchants');
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.source_onboarding = '';
      this.search.merchant_name = '';
      this.search.nmid = '';
      this.search.mpan = '';
      this.search.mobile_phone = '';
      this.search.mid = '';
      this.search.merchant_criteria = '';
      this.search.qr_type = '';
      this.search.sn = '';
      this.search.address = '';
      this.search.status = '';
      this.search.created_at = null;
      this.search.deactivated_at = null;
      this.$nextTick(() => {
        this.getData();
      });
    },

    getData() {
      this.$store.commit('inputer/merchant/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('inputer/merchant/fetchMerchants', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          merchantId: null,
          action: 'merchant',
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage == 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    editItem(item) {
      this.$router.push({
        path: `/inputer/merchant/update/${item.id}/pten`,
      });
    },

    editItemNon(item) {
      this.$router.push({
        path: `/inputer/merchant/update/${item.id}/non-pten`,
      });
    },

    listItem(item) {
      this.$router.push({
        path: `/inputer/merchant/${item.id}/list-outlet`,
      });
    },

    closeMerchant(item) {
      this.$router.push({ path: `/inputer/merchant/close/${item.id}` });
    },

    blockUnblockMerchant(item) {
      this.$router.push({ path: `/inputer/merchant/block-unblock/${item.id}` });
    },

    closeFlash() {
      this.$store.commit('inputer/merchant/setFlashErrorMessage', '');
    },

    registerMerchant() {
      this.$router.push({ path: '/client/merchant/register' });
    },

    openSerialNumberDialog(item) {
      this.dialog = true;
      this.formSn = {
        id: item.id,
        mid: item.mid,
        merchant_name: item.merchant_name,
        sn: item.sn || '',
      };
    },

    cancel() {
      this.dialog = false;
    },

    async save(formData) {
      try {
        await this.$store.dispatch('inputer/merchant/updateSerialNumber', {
          date,
          account_id: formData.id,
          mid: formData.mid,
          sn: formData.sn,
        });
        this.dialog = false;
        this.getData();
      } catch (error) {
        this.$store.commit('setSnackbar', {
          status: true,
          message: 'Something went wrong!',
          icon: 'mdi-alert-circle',
          color: 'red',
        });
      }
    },

    exportItem() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store.dispatch('inputer/merchant/exportList', {
        date,
        page,
        itemsPerPage,
        sortBy,
        sortDesc,
        search: this.search,
        view: 'merchant',
        IDMerchant: '',
      });
    },
    
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
@media only screen and (min-width: 600px) {
  .fixed-row {
    position: -webkit-sticky;
    position: sticky;
    top: 48px;
    z-index: 1;
    background-color: white;
  }
}
</style>
